import { ReactNode } from 'react';
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
  DraggableProvided,
} from '@hello-pangea/dnd';

type DraggableEntry = {
  id?: string;
};

type DraggableContainerProps<T extends DraggableEntry> = {
  children: (provider: DraggableProvided, entry: T, index: number) => ReactNode;
  entries: T[];
  onDragEnd: (dropResult: DropResult) => void;
};

export function DraggableContainer<T extends DraggableEntry>({
  children,
  entries,
  onDragEnd,
}: DraggableContainerProps<T>) {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="images">
        {(droppableProvider) => (
          <div
            ref={droppableProvider.innerRef}
            {...droppableProvider.droppableProps}
          >
            {entries.map((value, index) => (
              <Draggable
                index={index}
                key={`${value.id || JSON.stringify(value)}-${index}`}
                draggableId={`${value.id || JSON.stringify(value)}-${index}`}
                disableInteractiveElementBlocking={true}
              >
                {(draggableProvider) => (
                  <div
                    ref={draggableProvider.innerRef}
                    {...draggableProvider.draggableProps}
                  >
                    {children(draggableProvider, value, index)}
                  </div>
                )}
              </Draggable>
            ))}
            {droppableProvider.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
